import StaticPage from '../components/StaticPage';

export default function CareersPage() {
  return (
    <StaticPage title="Careers">
      <p>halfprice.ca is a growing local platform built by Izenious Tech Solutions in Winnipeg, Manitoba. We're early-stage right now — currently a small, founder-led team focused on bringing the best local restaurant deals to Winnipeg diners.</p>

      <h2>We're Not Actively Hiring Yet</h2>
      <p>As we grow across Winnipeg and expand into new cities, we'll be looking for people who share our passion for local restaurants and community-first business. Roles we expect to open in the future include local sales/business development, customer support, and marketing.</p>

      <h2>Stay in the Loop</h2>
      <p>If you're interested in future opportunities with halfprice.ca, feel free to introduce yourself at <a href="mailto:hello@halfprice.ca">hello@halfprice.ca</a>. We keep good notes and reach out as positions open.</p>
    </StaticPage>
  );
}
